const countries = [
  {
    id: "993",
    code: "999",
    isoCode: "ZZZ",
    name: "Not Assigned",
    state: "Active",
  },
  {
    id: "20",
    code: "AD",
    isoCode: "AND",
    name: "Andorran",
    state: "Active",
  },
  {
    id: "784",
    code: "AE",
    isoCode: "ARE",
    name: "Utd.Arab Emir.",
    state: "Active",
  },
  {
    id: "4",
    code: "AF",
    isoCode: "AFG",
    name: "Afghanistan",
    state: "Suspended",
  },
  {
    id: "28",
    code: "AG",
    isoCode: "ATG",
    name: "Antigua/Barbuda",
    state: "Active",
  },
  {
    id: "660",
    code: "AI",
    isoCode: "AIA",
    name: "Anguilla",
    state: "Active",
  },
  {
    id: "8",
    code: "AL",
    isoCode: "ALB",
    name: "Albania",
    state: "Suspended",
  },
  {
    id: "51",
    code: "AM",
    isoCode: "ARM",
    name: "Armenia",
    state: "Active",
  },
  {
    id: "995",
    code: "AN",
    isoCode: "ANT",
    name: "Dutch Antilles",
    state: "Active",
  },
  {
    id: "24",
    code: "AO",
    isoCode: "AGO",
    name: "Angola",
    state: "Active",
  },
  {
    id: "10",
    code: "AQ",
    isoCode: "ATA",
    name: "Antarctica",
    state: "Suspended",
  },
  {
    id: "32",
    code: "AR",
    isoCode: "ARG",
    name: "Argentina",
    state: "Suspended",
  },
  {
    id: "16",
    code: "AS",
    isoCode: "ASM",
    name: "Samoa, America",
    state: "Active",
  },
  {
    id: "40",
    code: "AT",
    isoCode: "AUT",
    name: "Austria",
    state: "Suspended",
  },
  {
    id: "36",
    code: "AU",
    isoCode: "AUS",
    name: "Australia",
    state: "Active",
  },
  {
    id: "533",
    code: "AW",
    isoCode: "ABW",
    name: "Aruba",
    state: "Suspended",
  },
  {
    id: "31",
    code: "AZ",
    isoCode: "AZE",
    name: "Azerbaijan",
    state: "Active",
  },
  {
    id: "70",
    code: "BA",
    isoCode: "BIH",
    name: "Bosnia-Herz.",
    state: "Active",
  },
  {
    id: "52",
    code: "BB",
    isoCode: "BRB",
    name: "Barbados",
    state: "Active",
  },
  {
    id: "50",
    code: "BD",
    isoCode: "BGD",
    name: "Bangladesh",
    state: "Suspended",
  },
  {
    id: "56",
    code: "BE",
    isoCode: "BEL",
    name: "Belgium",
    state: "Active",
  },
  {
    id: "854",
    code: "BF",
    isoCode: "BFA",
    name: "Burkina Faso",
    state: "Active",
  },
  {
    id: "100",
    code: "BG",
    isoCode: "BGR",
    name: "Bulgaria",
    state: "Active",
  },
  {
    id: "48",
    code: "BH",
    isoCode: "BHR",
    name: "Bahrain",
    state: "Active",
  },
  {
    id: "108",
    code: "BI",
    isoCode: "BDI",
    name: "Burundi",
    state: "Active",
  },
  {
    id: "204",
    code: "BJ",
    isoCode: "BEN",
    name: "Benin",
    state: "Active",
  },
  {
    id: "590",
    code: "BL",
    isoCode: "BLM",
    name: "Saint Barthelem",
    state: "Active",
  },
  {
    id: "60",
    code: "BM",
    isoCode: "BMU",
    name: "Bermuda",
    state: "Active",
  },
  {
    id: "96",
    code: "BN",
    isoCode: "BRN",
    name: "Brunei Daruss.",
    state: "Active",
  },
  {
    id: "68",
    code: "BO",
    isoCode: "BOL",
    name: "Bolivia",
    state: "Active",
  },
  {
    id: "76",
    code: "BR",
    isoCode: "BRA",
    name: "Brazil",
    state: "Active",
  },
  {
    id: "44",
    code: "BS",
    isoCode: "BHS",
    name: "Bahamas",
    state: "Active",
  },
  {
    id: "64",
    code: "BT",
    isoCode: "BTN",
    name: "Bhutan",
    state: "Active",
  },
  {
    id: "74",
    code: "BV",
    isoCode: "BVT",
    name: "Bouvet Islands",
    state: "Active",
  },
  {
    id: "72",
    code: "BW",
    isoCode: "BWA",
    name: "Botswana",
    state: "Active",
  },
  {
    id: "112",
    code: "BY",
    isoCode: "BLR",
    name: "Belarus",
    state: "Active",
  },
  {
    id: "84",
    code: "BZ",
    isoCode: "BLZ",
    name: "Belize",
    state: "Active",
  },
  {
    id: "124",
    code: "CA",
    isoCode: "CAN",
    name: "Canada",
    state: "Active",
  },
  {
    id: "166",
    code: "CC",
    isoCode: "CCK",
    name: "Coconut Islands",
    state: "Active",
  },
  {
    id: "180",
    code: "CD",
    isoCode: "COD",
    name: "Dem. Rep. Congo",
    state: "Active",
  },
  {
    id: "140",
    code: "CF",
    isoCode: "CAF",
    name: "Cent. African R",
    state: "Active",
  },
  {
    id: "178",
    code: "CG",
    isoCode: "COG",
    name: "Rep.of Congo",
    state: "Active",
  },
  {
    id: "756",
    code: "CH",
    isoCode: "CHE",
    name: "Switzerland",
    state: "Active",
  },
  {
    id: "384",
    code: "CI",
    isoCode: "CIV",
    name: "Cote d'Ivoire",
    state: "Active",
  },
  {
    id: "184",
    code: "CK",
    isoCode: "COK",
    name: "Cook Islands",
    state: "Active",
  },
  {
    id: "152",
    code: "CL",
    isoCode: "CHL",
    name: "Chile",
    state: "Active",
  },
  {
    id: "120",
    code: "CM",
    isoCode: "CMR",
    name: "Cameroon",
    state: "Active",
  },
  {
    id: "156",
    code: "CN",
    isoCode: "CHN",
    name: "China",
    state: "Active",
  },
  {
    id: "170",
    code: "CO",
    isoCode: "COL",
    name: "Colombia",
    state: "Active",
  },
  {
    id: "188",
    code: "CR",
    isoCode: "CRI",
    name: "Costa Rica",
    state: "Active",
  },
  {
    id: "891",
    code: "CS",
    isoCode: "SCG",
    name: "Serbia/Monten.",
    state: "Active",
  },
  {
    id: "192",
    code: "CU",
    isoCode: "CUB",
    name: "Cuba",
    state: "Active",
  },
  {
    id: "132",
    code: "CV",
    isoCode: "CPV",
    name: "Cape Verde",
    state: "Active",
  },
  {
    id: "162",
    code: "CX",
    isoCode: "CXR",
    name: "Christmas Islnd",
    state: "Active",
  },
  {
    id: "196",
    code: "CY",
    isoCode: "CYP",
    name: "Cyprus",
    state: "Active",
  },
  {
    id: "203",
    code: "CZ",
    isoCode: "CZE",
    name: "Czech Republic",
    state: "Active",
  },
  {
    id: "276",
    code: "DE",
    isoCode: "DEU",
    name: "Germany",
    state: "Active",
  },
  {
    id: "262",
    code: "DJ",
    isoCode: "DJI",
    name: "Djibouti",
    state: "Active",
  },
  {
    id: "208",
    code: "DK",
    isoCode: "DNK",
    name: "Denmark",
    state: "Active",
  },
  {
    id: "212",
    code: "DM",
    isoCode: "DMA",
    name: "Dominica",
    state: "Active",
  },
  {
    id: "214",
    code: "DO",
    isoCode: "DOM",
    name: "Dominican Rep.",
    state: "Active",
  },
  {
    id: "12",
    code: "DZ",
    isoCode: "DZA",
    name: "Algeria",
    state: "Suspended",
  },
  {
    id: "218",
    code: "EC",
    isoCode: "ECU",
    name: "Ecuador",
    state: "Active",
  },
  {
    id: "233",
    code: "EE",
    isoCode: "EST",
    name: "Estonia",
    state: "Active",
  },
  {
    id: "818",
    code: "EG",
    isoCode: "EGY",
    name: "Egypt",
    state: "Active",
  },
  {
    id: "732",
    code: "EH",
    isoCode: "ESH",
    name: "West Sahara",
    state: "Active",
  },
  {
    id: "232",
    code: "ER",
    isoCode: "ERI",
    name: "Eritrea",
    state: "Active",
  },
  {
    id: "724",
    code: "ES",
    isoCode: "ESP",
    name: "Spain",
    state: "Active",
  },
  {
    id: "231",
    code: "ET",
    isoCode: "ETH",
    name: "Ethiopia",
    state: "Active",
  },
  {
    id: "999",
    code: "EU",
    name: "European Union",
    state: "Active",
  },
  {
    id: "246",
    code: "FI",
    isoCode: "FIN",
    name: "Finland",
    state: "Active",
  },
  {
    id: "242",
    code: "FJ",
    isoCode: "FJI",
    name: "Fiji",
    state: "Active",
  },
  {
    id: "238",
    code: "FK",
    isoCode: "FLK",
    name: "Falkland Islnds",
    state: "Active",
  },
  {
    id: "583",
    code: "FM",
    isoCode: "FSM",
    name: "Micronesia",
    state: "Active",
  },
  {
    id: "234",
    code: "FO",
    isoCode: "FRO",
    name: "Faroe Islands",
    state: "Active",
  },
  {
    id: "250",
    code: "FR",
    isoCode: "FRA",
    name: "France",
    state: "Active",
  },
  {
    id: "266",
    code: "GA",
    isoCode: "GAB",
    name: "Gabon",
    state: "Suspended",
  },
  {
    id: "826",
    code: "GB",
    isoCode: "GBR",
    name: "United Kingdom",
    state: "Active",
  },
  {
    id: "308",
    code: "GD",
    isoCode: "GRD",
    name: "Grenada",
    state: "Active",
  },
  {
    id: "268",
    code: "GE",
    isoCode: "GEO",
    name: "Georgia",
    state: "Active",
  },
  {
    id: "254",
    code: "GF",
    isoCode: "GUF",
    name: "French Guayana",
    state: "Active",
  },
  {
    id: "288",
    code: "GH",
    isoCode: "GHA",
    name: "Ghana",
    state: "Active",
  },
  {
    id: "292",
    code: "GI",
    isoCode: "GIB",
    name: "Gibraltar",
    state: "Active",
  },
  {
    id: "304",
    code: "GL",
    isoCode: "GRL",
    name: "Greenland",
    state: "Active",
  },
  {
    id: "270",
    code: "GM",
    isoCode: "GMB",
    name: "Gambia",
    state: "Active",
  },
  {
    id: "324",
    code: "GN",
    isoCode: "GIN",
    name: "Guinea",
    state: "Active",
  },
  {
    id: "312",
    code: "GP",
    isoCode: "GLP",
    name: "Guadeloupe",
    state: "Active",
  },
  {
    id: "226",
    code: "GQ",
    isoCode: "GNQ",
    name: "Equatorial Guin",
    state: "Active",
  },
  {
    id: "300",
    code: "GR",
    isoCode: "GRC",
    name: "Greece",
    state: "Active",
  },
  {
    id: "239",
    code: "GS",
    isoCode: "SGS",
    name: "S. Sandwich Ins",
    state: "Active",
  },
  {
    id: "320",
    code: "GT",
    isoCode: "GTM",
    name: "Guatemala",
    state: "Active",
  },
  {
    id: "316",
    code: "GU",
    isoCode: "GUM",
    name: "Guam",
    state: "Active",
  },
  {
    id: "624",
    code: "GW",
    isoCode: "GNB",
    name: "Guinea-Bissau",
    state: "Active",
  },
  {
    id: "328",
    code: "GY",
    isoCode: "GUY",
    name: "Guyana",
    state: "Active",
  },
  {
    id: "344",
    code: "HK",
    isoCode: "HKG",
    name: "Hong Kong",
    state: "Active",
  },
  {
    id: "334",
    code: "HM",
    isoCode: "HMD",
    name: "Heard/McDon.Isl",
    state: "Active",
  },
  {
    id: "340",
    code: "HN",
    isoCode: "HND",
    name: "Honduras",
    state: "Active",
  },
  {
    id: "191",
    code: "HR",
    isoCode: "HRV",
    name: "Croatia",
    state: "Active",
  },
  {
    id: "332",
    code: "HT",
    isoCode: "HTI",
    name: "Haiti",
    state: "Active",
  },
  {
    id: "348",
    code: "HU",
    isoCode: "HUN",
    name: "Hungary",
    state: "Active",
  },
  {
    id: "360",
    code: "ID",
    isoCode: "IDN",
    name: "Indonesia",
    state: "Active",
  },
  {
    id: "372",
    code: "IE",
    isoCode: "IRL",
    name: "Ireland",
    state: "Active",
  },
  {
    id: "376",
    code: "IL",
    isoCode: "ISR",
    name: "Israel",
    state: "Active",
  },
  {
    id: "356",
    code: "IN",
    isoCode: "IND",
    name: "India",
    state: "Active",
  },
  {
    id: "86",
    code: "IO",
    isoCode: "IOT",
    name: "Brit.Ind.Oc.Ter",
    state: "Active",
  },
  {
    id: "368",
    code: "IQ",
    isoCode: "IRQ",
    name: "Iraq",
    state: "Active",
  },
  {
    id: "364",
    code: "IR",
    isoCode: "IRN",
    name: "Iran",
    state: "Active",
  },
  {
    id: "352",
    code: "IS",
    isoCode: "ISL",
    name: "Iceland",
    state: "Active",
  },
  {
    id: "380",
    code: "IT",
    isoCode: "ITA",
    name: "Italy",
    state: "Active",
  },
  {
    id: "388",
    code: "JM",
    isoCode: "JAM",
    name: "Jamaica",
    state: "Active",
  },
  {
    id: "400",
    code: "JO",
    isoCode: "JOR",
    name: "Jordan",
    state: "Active",
  },
  {
    id: "392",
    code: "JP",
    isoCode: "JPN",
    name: "Japan",
    state: "Active",
  },
  {
    id: "404",
    code: "KE",
    isoCode: "KEN",
    name: "Kenya",
    state: "Active",
  },
  {
    id: "417",
    code: "KG",
    isoCode: "KGZ",
    name: "Kyrgyzstan",
    state: "Active",
  },
  {
    id: "116",
    code: "KH",
    isoCode: "KHM",
    name: "Cambodia",
    state: "Active",
  },
  {
    id: "296",
    code: "KI",
    isoCode: "KIR",
    name: "Kiribati",
    state: "Active",
  },
  {
    id: "174",
    code: "KM",
    isoCode: "COM",
    name: "Comoros",
    state: "Active",
  },
  {
    id: "659",
    code: "KN",
    isoCode: "KNA",
    name: "St Kitts&Nevis",
    state: "Active",
  },
  {
    id: "408",
    code: "KP",
    isoCode: "PRK",
    name: "North Korea",
    state: "Active",
  },
  {
    id: "410",
    code: "KR",
    isoCode: "KOR",
    name: "South Korea",
    state: "Active",
  },
  {
    id: "414",
    code: "KW",
    isoCode: "KWT",
    name: "Kuwait",
    state: "Active",
  },
  {
    id: "136",
    code: "KY",
    isoCode: "CYM",
    name: "Cayman Islands",
    state: "Active",
  },
  {
    id: "398",
    code: "KZ",
    isoCode: "KAZ",
    name: "Kazakhstan",
    state: "Active",
  },
  {
    id: "418",
    code: "LA",
    isoCode: "LAO",
    name: "Laos",
    state: "Active",
  },
  {
    id: "422",
    code: "LB",
    isoCode: "LBN",
    name: "Lebanon",
    state: "Active",
  },
  {
    id: "662",
    code: "LC",
    isoCode: "LCA",
    name: "St. Lucia",
    state: "Active",
  },
  {
    id: "438",
    code: "LI",
    isoCode: "LIE",
    name: "Liechtenstein",
    state: "Active",
  },
  {
    id: "144",
    code: "LK",
    isoCode: "LKA",
    name: "Sri Lanka",
    state: "Active",
  },
  {
    id: "430",
    code: "LR",
    isoCode: "LBR",
    name: "Liberia",
    state: "Active",
  },
  {
    id: "426",
    code: "LS",
    isoCode: "LSO",
    name: "Lesotho",
    state: "Active",
  },
  {
    id: "440",
    code: "LT",
    isoCode: "LTU",
    name: "Lithuania",
    state: "Active",
  },
  {
    id: "442",
    code: "LU",
    isoCode: "LUX",
    name: "Luxembourg",
    state: "Active",
  },
  {
    id: "428",
    code: "LV",
    isoCode: "LVA",
    name: "Latvia",
    state: "Active",
  },
  {
    id: "434",
    code: "LY",
    isoCode: "LBY",
    name: "Libya",
    state: "Active",
  },
  {
    id: "504",
    code: "MA",
    isoCode: "MAR",
    name: "Morocco",
    state: "Suspended",
  },
  {
    id: "492",
    code: "MC",
    isoCode: "MCO",
    name: "Monaco",
    state: "Active",
  },
  {
    id: "498",
    code: "MD",
    isoCode: "MDA",
    name: "Moldova",
    state: "Active",
  },
  {
    id: "499",
    code: "ME",
    isoCode: "MNE",
    name: "Montenegro",
    state: "Active",
  },
  {
    id: "450",
    code: "MG",
    isoCode: "MDG",
    name: "Madagascar",
    state: "Active",
  },
  {
    id: "584",
    code: "MH",
    isoCode: "MHL",
    name: "Marshall Islnds",
    state: "Active",
  },
  {
    id: "807",
    code: "MK",
    isoCode: "MKD",
    name: "Macedonia",
    state: "Active",
  },
  {
    id: "466",
    code: "ML",
    isoCode: "MLI",
    name: "Mali",
    state: "Suspended",
  },
  {
    id: "104",
    code: "MM",
    isoCode: "MMR",
    name: "Burma",
    state: "Active",
  },
  {
    id: "496",
    code: "MN",
    isoCode: "MNG",
    name: "Mongolia",
    state: "Active",
  },
  {
    id: "446",
    code: "MO",
    isoCode: "MAC",
    name: "Macau",
    state: "Active",
  },
  {
    id: "580",
    code: "MP",
    isoCode: "MNP",
    name: "N.Mariana Islnd",
    state: "Active",
  },
  {
    id: "474",
    code: "MQ",
    isoCode: "MTQ",
    name: "Martinique",
    state: "Active",
  },
  {
    id: "478",
    code: "MR",
    isoCode: "MRT",
    name: "Mauritania",
    state: "Active",
  },
  {
    id: "500",
    code: "MS",
    isoCode: "MSR",
    name: "Montserrat",
    state: "Active",
  },
  {
    id: "470",
    code: "MT",
    isoCode: "MLT",
    name: "Malta",
    state: "Active",
  },
  {
    id: "480",
    code: "MU",
    isoCode: "MUS",
    name: "Mauritius",
    state: "Active",
  },
  {
    id: "462",
    code: "MV",
    isoCode: "MDV",
    name: "Maldives",
    state: "Active",
  },
  {
    id: "454",
    code: "MW",
    isoCode: "MWI",
    name: "Malawi",
    state: "Active",
  },
  {
    id: "484",
    code: "MX",
    isoCode: "MEX",
    name: "Mexico",
    state: "Active",
  },
  {
    id: "458",
    code: "MY",
    isoCode: "MYS",
    name: "Malaysia",
    state: "Active",
  },
  {
    id: "508",
    code: "MZ",
    isoCode: "MOZ",
    name: "Mozambique",
    state: "Active",
  },
  {
    id: "516",
    code: "NA",
    isoCode: "NAM",
    name: "Namibia",
    state: "Active",
  },
  {
    id: "540",
    code: "NC",
    isoCode: "NCL",
    name: "New Caledonia",
    state: "Active",
  },
  {
    id: "562",
    code: "NE",
    isoCode: "NER",
    name: "Niger",
    state: "Active",
  },
  {
    id: "574",
    code: "NF",
    isoCode: "NFK",
    name: "Norfolk Islands",
    state: "Active",
  },
  {
    id: "566",
    code: "NG",
    isoCode: "NGA",
    name: "Nigeria",
    state: "Active",
  },
  {
    id: "558",
    code: "NI",
    isoCode: "NIC",
    name: "Nicaragua",
    state: "Active",
  },
  {
    id: "530",
    code: "NL",
    isoCode: "NLD",
    name: "Netherlands",
    state: "Active",
  },
  {
    id: "578",
    code: "NO",
    isoCode: "NOR",
    name: "Norway",
    state: "Active",
  },
  {
    id: "524",
    code: "NP",
    isoCode: "NPL",
    name: "Nepal",
    state: "Active",
  },
  {
    id: "520",
    code: "NR",
    isoCode: "NRU",
    name: "Nauru",
    state: "Active",
  },
  {
    id: "998",
    code: "NT",
    isoCode: "NTA",
    name: "NATO",
    state: "Active",
  },
  {
    id: "570",
    code: "NU",
    isoCode: "NIU",
    name: "Niue",
    state: "Active",
  },
  {
    id: "554",
    code: "NZ",
    isoCode: "NZL",
    name: "New Zealand",
    state: "Active",
  },
  {
    id: "512",
    code: "OM",
    isoCode: "OMN",
    name: "Oman",
    state: "Active",
  },
  {
    id: "997",
    code: "OR",
    isoCode: "ORA",
    name: "Orange",
    state: "Active",
  },
  {
    id: "591",
    code: "PA",
    isoCode: "PAN",
    name: "Panama",
    state: "Active",
  },
  {
    id: "604",
    code: "PE",
    isoCode: "PER",
    name: "Peru",
    state: "Active",
  },
  {
    id: "258",
    code: "PF",
    isoCode: "PYF",
    name: "Frenc.Polynesia",
    state: "Active",
  },
  {
    id: "598",
    code: "PG",
    isoCode: "PNG",
    name: "Pap. New Guinea",
    state: "Active",
  },
  {
    id: "608",
    code: "PH",
    isoCode: "PHL",
    name: "Philippines",
    state: "Active",
  },
  {
    id: "586",
    code: "PK",
    isoCode: "PAK",
    name: "Pakistan",
    state: "Active",
  },
  {
    id: "616",
    code: "PL",
    isoCode: "POL",
    name: "Poland",
    state: "Active",
  },
  {
    id: "666",
    code: "PM",
    isoCode: "SPM",
    name: "St.Pier,Miquel.",
    state: "Active",
  },
  {
    id: "612",
    code: "PN",
    isoCode: "PCN",
    name: "Pitcairn Islnds",
    state: "Active",
  },
  {
    id: "630",
    code: "PR",
    isoCode: "PRI",
    name: "Puerto Rico",
    state: "Active",
  },
  {
    id: "275",
    code: "PS",
    isoCode: "PSE",
    name: "Palestine",
    state: "Suspended",
  },
  {
    id: "620",
    code: "PT",
    isoCode: "PRT",
    name: "Portugal",
    state: "Active",
  },
  {
    id: "585",
    code: "PW",
    isoCode: "PLW",
    name: "Palau",
    state: "Active",
  },
  {
    id: "600",
    code: "PY",
    isoCode: "PRY",
    name: "Paraguay",
    state: "Active",
  },
  {
    id: "634",
    code: "QA",
    isoCode: "QAT",
    name: "Qatar",
    state: "Active",
  },
  {
    id: "638",
    code: "RE",
    isoCode: "REU",
    name: "Reunion",
    state: "Active",
  },
  {
    id: "642",
    code: "RO",
    isoCode: "ROM",
    name: "Romania",
    state: "Active",
  },
  {
    id: "688",
    code: "RS",
    isoCode: "SRB",
    name: "Serbia",
    state: "Active",
  },
  {
    id: "643",
    code: "RU",
    isoCode: "RUS",
    name: "Russian Fed.",
    state: "Active",
  },
  {
    id: "646",
    code: "RW",
    isoCode: "RWA",
    name: "Rwanda",
    state: "Active",
  },
  {
    id: "682",
    code: "SA",
    isoCode: "SAU",
    name: "Saudi Arabia",
    state: "Active",
  },
  {
    id: "90",
    code: "SB",
    isoCode: "SLB",
    name: "Solomon Islands",
    state: "Active",
  },
  {
    id: "690",
    code: "SC",
    isoCode: "SYC",
    name: "Seychelles",
    state: "Suspended",
  },
  {
    id: "736",
    code: "SD",
    isoCode: "SDN",
    name: "Sudan",
    state: "Suspended",
  },
  {
    id: "752",
    code: "SE",
    isoCode: "SWE",
    name: "Sweden",
    state: "Active",
  },
  {
    id: "702",
    code: "SG",
    isoCode: "SGP",
    name: "Singapore",
    state: "Active",
  },
  {
    id: "654",
    code: "SH",
    isoCode: "SHN",
    name: "Saint Helena",
    state: "Active",
  },
  {
    id: "705",
    code: "SI",
    isoCode: "SVN",
    name: "Slovenia",
    state: "Active",
  },
  {
    id: "744",
    code: "SJ",
    isoCode: "SJM",
    name: "Svalbard",
    state: "Active",
  },
  {
    id: "703",
    code: "SK",
    isoCode: "SVK",
    name: "Slovakia",
    state: "Active",
  },
  {
    id: "694",
    code: "SL",
    isoCode: "SLE",
    name: "Sierra Leone",
    state: "Active",
  },
  {
    id: "674",
    code: "SM",
    isoCode: "SMR",
    name: "San Marino",
    state: "Active",
  },
  {
    id: "686",
    code: "SN",
    isoCode: "SEN",
    name: "Senegal",
    state: "Suspended",
  },
  {
    id: "706",
    code: "SO",
    isoCode: "SOM",
    name: "Somalia",
    state: "Active",
  },
  {
    id: "740",
    code: "SR",
    isoCode: "SUR",
    name: "Suriname",
    state: "Active",
  },
  {
    id: "678",
    code: "ST",
    isoCode: "STP",
    name: "S.Tome,Principe",
    state: "Active",
  },
  {
    id: "222",
    code: "SV",
    isoCode: "SLV",
    name: "El Salvador",
    state: "Active",
  },
  {
    id: "760",
    code: "SY",
    isoCode: "SYR",
    name: "Syria",
    state: "Suspended",
  },
  {
    id: "748",
    code: "SZ",
    isoCode: "SWZ",
    name: "Swaziland",
    state: "Active",
  },
  {
    id: "796",
    code: "TC",
    isoCode: "TCA",
    name: "Turksh Caicosin",
    state: "Active",
  },
  {
    id: "148",
    code: "TD",
    isoCode: "TCD",
    name: "Chad",
    state: "Active",
  },
  {
    id: "260",
    code: "TF",
    isoCode: "ATF",
    name: "French S.Territ",
    state: "Active",
  },
  {
    id: "768",
    code: "TG",
    isoCode: "TGO",
    name: "Togo",
    state: "Active",
  },
  {
    id: "764",
    code: "TH",
    isoCode: "THA",
    name: "Thailand",
    state: "Active",
  },
  {
    id: "762",
    code: "TJ",
    isoCode: "TJK",
    name: "Tajikistan",
    state: "Active",
  },
  {
    id: "772",
    code: "TK",
    isoCode: "TKL",
    name: "Tokelau Islands",
    state: "Active",
  },
  {
    id: "626",
    code: "TL",
    isoCode: "TLS",
    name: "East Timor",
    state: "Active",
  },
  {
    id: "795",
    code: "TM",
    isoCode: "TKM",
    name: "Turkmenistan",
    state: "Active",
  },
  {
    id: "788",
    code: "TN",
    isoCode: "TUN",
    name: "Tunisia",
    state: "Active",
  },
  {
    id: "776",
    code: "TO",
    isoCode: "TON",
    name: "Tonga",
    state: "Active",
  },
  {
    id: "626",
    code: "TP",
    isoCode: "TMP",
    name: "East Timor",
    state: "Active",
  },
  {
    id: "792",
    code: "TR",
    isoCode: "TUR",
    name: "Turkey",
    state: "Active",
  },
  {
    id: "780",
    code: "TT",
    isoCode: "TTO",
    name: "Trinidad,Tobago",
    state: "Active",
  },
  {
    id: "798",
    code: "TV",
    isoCode: "TUV",
    name: "Tuvalu",
    state: "Active",
  },
  {
    id: "158",
    code: "TW",
    isoCode: "TWN",
    name: "Taiwan",
    state: "Active",
  },
  {
    id: "834",
    code: "TZ",
    isoCode: "TZA",
    name: "Tanzania",
    state: "Active",
  },
  {
    id: "804",
    code: "UA",
    isoCode: "UKR",
    name: "Ukraine",
    state: "Active",
  },
  {
    id: "800",
    code: "UG",
    isoCode: "UGA",
    name: "Uganda",
    state: "Active",
  },
  {
    id: "581",
    code: "UM",
    isoCode: "UMI",
    name: "Minor Outl.Isl.",
    state: "Active",
  },
  {
    id: "996",
    code: "UN",
    isoCode: "UNA",
    name: "United Nations",
    state: "Active",
  },
  {
    id: "840",
    code: "US",
    isoCode: "USA",
    name: "USA",
    state: "Active",
  },
  {
    id: "858",
    code: "UY",
    isoCode: "URY",
    name: "Uruguay",
    state: "Active",
  },
  {
    id: "860",
    code: "UZ",
    isoCode: "UZB",
    name: "Uzbekistan",
    state: "Active",
  },
  {
    id: "336",
    code: "VA",
    isoCode: "VAT",
    name: "Vatican City",
    state: "Active",
  },
  {
    id: "670",
    code: "VC",
    isoCode: "VCT",
    name: "St. Vincent",
    state: "Active",
  },
  {
    id: "862",
    code: "VE",
    isoCode: "VEN",
    name: "Venezuela",
    state: "Active",
  },
  {
    id: "92",
    code: "VG",
    isoCode: "VGB",
    name: "Brit.Virgin Is.",
    state: "Active",
  },
  {
    id: "850",
    code: "VI",
    isoCode: "VIR",
    name: "Amer.Virgin Is.",
    state: "Active",
  },
  {
    id: "704",
    code: "VN",
    isoCode: "VNM",
    name: "Vietnam",
    state: "Active",
  },
  {
    id: "548",
    code: "VU",
    isoCode: "VUT",
    name: "Vanuatu",
    state: "Active",
  },
  {
    id: "876",
    code: "WF",
    isoCode: "WLF",
    name: "Wallis,Futuna",
    state: "Active",
  },
  {
    id: "882",
    code: "WS",
    isoCode: "WSM",
    name: "Samoa",
    state: "Active",
  },
  {
    id: "381",
    code: "XK",
    isoCode: "KSV",
    name: "Kosovo",
    state: "Active",
  },
  {
    id: "887",
    code: "YE",
    isoCode: "YEM",
    name: "Yemen",
    state: "Active",
  },
  {
    id: "175",
    code: "YT",
    isoCode: "MYT",
    name: "Mayotte",
    state: "Active",
  },
  {
    id: "710",
    code: "ZA",
    isoCode: "ZAF",
    name: "South Africa",
    state: "Active",
  },
  {
    id: "894",
    code: "ZM",
    isoCode: "ZMB",
    name: "Zambia",
    state: "Active",
  },
  {
    id: "716",
    code: "ZW",
    isoCode: "ZWE",
    name: "Zimbabwe",
    state: "Active",
  },
];

export default countries;
